export type SkuPickerDisplayFields = {
  sku: string;
  category?: string | null;
  description?: string | null;
  variant?: string | null;
};

/** First line for tight SKU pickers: `SKU (category)` when category is set. */
export function skuPickerTitleLine(fields: SkuPickerDisplayFields): string {
  const category = fields.category?.trim();
  if (category != null && category !== "") {
    return `${fields.sku} (${category})`;
  }
  return fields.sku;
}

/** Second line for tight SKU pickers: description and variant joined with one space. */
export function skuPickerDescriptionLine(fields: SkuPickerDisplayFields): string {
  const parts = [fields.description?.trim(), fields.variant?.trim()].filter(
    (part): part is string => part != null && part !== "",
  );
  return parts.length > 0 ? parts.join(" ") : "";
}
